// components/PrivateRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React from 'react';

interface AuthState {
  isAuthenticated: boolean;
}

const PrivateRoute: React.FC = () => {
  const isAuthenticated = useSelector((state: { auth: AuthState }) => state.auth.isAuthenticated);

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
